module.exports = __webpack_public_path__ + "img/trees-illustration.48f3883f.svg";